'use client';

import React from 'react';
import { toast } from 'sonner';
import { useLanguage } from '@/context/LanguageContext';
import type { Language } from '@/lib/i18n';
import { translate } from '@/lib/i18n';

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();

  function handleSelect(newLang: Language) {
    setLang(newLang);
    // Fire toast in the newly selected language
    toast.success(translate(newLang, 'toast.languageSwitched'));
  }

  return (
    <div
      className="inline-flex items-center p-0.5 flex-shrink-0"
      style={{
        border: '1px solid var(--border)',
        borderRadius: '8px',
        backgroundColor: 'var(--background)',
        gap: '2px',
      }}
    >
      {(['en', 'fr'] as Language[]).map((l) => {
        const isActive = lang === l;
        return (
          <button
            key={l}
            onClick={() => handleSelect(l)}
            aria-label={l === 'en' ? 'English' : 'Français'}
            aria-pressed={isActive}
            className="transition-all duration-150"
            style={{
              width: '30px',
              height: '22px',
              fontSize: '11px',
              fontWeight: 600,
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              backgroundColor: isActive ? 'var(--primary)' : 'transparent',
              color: isActive ? 'white' : 'var(--muted-foreground)',
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                (e.currentTarget as HTMLButtonElement).style.color = 'var(--foreground)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                (e.currentTarget as HTMLButtonElement).style.color = 'var(--muted-foreground)';
              }
            }}
          >
            {l.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
